import React, { useState, useEffect } from 'react';
import axios from 'axios';
import bgImg1 from '../assets/bg-img-1.jpg';
import logo from '../assets/logo.png'; 
import { Link, useNavigate } from 'react-router-dom';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(
        'https://thecfagroup.org/v1/api/admin/login',
        {
          email: formData.email,
          password: formData.password,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      
      console.log('Login Successful:', response.data);
      localStorage.setItem('token',response.data.token)
      // Handle successful login here (e.g., store tokens, navigate to another page)
      navigate('/')
    } catch (error) {
      console.error('Login Error:', error.response?.data || error.message);
      setErrorMessage('Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <div>
      <header className="absolute mt-5 top-0 left-0 right-0 flex items-center md:flex-row justify-between px-10 py-8 z-10 bg-transparent">
      {/* Logo */}
      <Link to='/'>
      <div className="flex items-center">
        <img src={logo} alt="Trydo Logo" className="h-[4.5rem] mr-3" /> 
      </div>
      </Link>
      {/* Hamburger Icon (visible on smaller screens only) */}
      {/* <div onClick={toggleMenu} className="cursor-pointer md:hidden">
        {menuOpen ? <GrClose className="text-black text-3xl" /> : <GiHamburgerMenu className="text-[#c6c9d8] text-3xl" />}
      </div> */}
      {/* Navigation Items (visible on larger screens) */}
      {/* <div className={`hidden md:flex items-center space-x-16`}>
        <nav className="flex space-x-8">
          <Link to="/" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Home</Link>
          <Link to="/about" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">About Us</Link>
          <Link to="/franchise" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Franchise Development</Link>
          <Link to="/advisory" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Advisory Services</Link>
          <Link to="/brand" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Brand Solutions</Link>
          <Link to="/experiential" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Experiential Marketing</Link>
          <Link to="/contact" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Contact Us</Link>
          {token && <button
          onClick={handleLogout}
              className="bg-red-500 text-white font-medium text-[16px] border border-red-600 rounded transition-all duration-300 hover:bg-red-600 hover:border-red-700 hover:text-white"
            >
              Log Out
            </button>}
        </nav>

      </div>
      <div className={`fixed top-0 right-0 z-100 bg-white w-[70%] h-screen transition-transform duration-300 ${menuOpen ? 'translate-x-0' : 'translate-x-full'} md:hidden`}>
        <div className="flex relative top-12 mb-2 right-7 justify-end p-4">
          <div onClick={toggleMenu} className="cursor-pointer">
            <GrClose className="text-black text-3xl" />
          </div>
        </div>
        <nav className="flex flex-col items-start p-8 space-y-4">
          <Link to="/" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Home</Link>
          <Link to="/about" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">About Us</Link>
          <Link to="/franchise" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Franchise Development</Link>
          <Link to="/advisory" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Advisory Services</Link>
          <Link to="/brand" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Brand Solutions</Link>
          <Link to="/experiential" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Experiential Marketing</Link>
          <Link to="/contact" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Contact Us</Link>
          {token && <button
          onClick={handleLogout}
              className="bg-red-500 text-white font-medium text-[16px] border border-red-600 rounded transition-all duration-300 hover:bg-red-600 hover:border-red-700 hover:text-white"
            >
              Log Out
            </button>}
        </nav>
      </div> */}
    </header>
      <div
        className="relative h-[40vh] sm:h-[50vh] bg-cover bg-center z-1"
        style={{ backgroundImage: `url(${bgImg1})` }}
      >
        <div className="absolute inset-0 bg-[#03000c] opacity-75"></div>

        <div className="absolute z-1 flex flex-col items-start justify-center min-h-full w-[90%] sm:w-[70%] px-4 mt-6 sm:px-10 md:px-16">
          <div className="text-white text-left px-4 py-6 w-full max-w-3xl mx-auto">
            <h1 className="text-[30px] sm:text-[50px] md:text-[70px] font-extrabold leading-tight mb-4 animate-fade-in-up">
              Login
            </h1>
          </div>
        </div>
      </div>

      <div className="flex justify-center flex-col gap-12 items-center pt-10 pb-10 sm:pt-16 sm:pb-16 px-4 bg-gray-100">
        <div className="w-full max-w-6xl p-6 sm:p-8 bg-white shadow-xl rounded-lg">
          <div className="w-full max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 sm:mb-8 text-center">Sign In</h1>
            {errorMessage && <p className="text-red-600 text-center">{errorMessage}</p>}
            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="border p-2 sm:p-3 w-full"
                required
              />
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                className="border p-2 sm:p-3 w-full"
                required
              />
              <button
                type="submit"
                className="bg-[#25a182] text-white py-2 sm:py-3 px-4 sm:px-6 rounded w-full hover:text-[#25a182] hover:bg-white hover:border hover:border-[#25a182] transition-transform duration-300 transform hover:translate-y-[-4px]"
                disabled={isLoading}
              >
                {isLoading ? 'Logging in...' : 'Log In'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
